// @flow
import React from 'react'
import i18n from 'i18next'

import Step from './Step'
import { Container } from './styles'

type Props = { activeStep: number }

export const Steps = (props: Props) => (
  <Container>
    <Step
      title={i18n.t('checkout.firstStep')}
      active={props.activeStep === 1}
    />

    <Step
      title={i18n.t('checkout.secondStep')}
      active={props.activeStep === 2}
    />

    <Step
      title={i18n.t('checkout.thirdStep')}
      active={props.activeStep === 3}
    />
  </Container>
)

export default Steps
